module.exports = __webpack_public_path__ + "bcc9aba9c58abfd7b929ee5bd27a6b6b.png";